import React from 'react';

import { useHelpBundle } from '@plasma/ui.application.app';
import { useResourceBundle, useTranslation } from '@plasma/ui.utils.i18n';

import translations from './i18n';
import { HomeScreenProps } from './home-screen';
import help from './home-screen.help';

function useHomeScreenHook(props: HomeScreenProps) {
  useResourceBundle(translations, undefined, 'fc9693cf-f1c4-4afc-a198-44af00f87252');
  useHelpBundle(help);

  const { t } = useTranslation();


  return {
    t,
  };
}

export default useHomeScreenHook;
